import { useModalDragConstraint } from "../../../components/Modal";
import { ModalTabs, ModalTab } from "../../../components/ModalTabs";
import type { TRangeSelection } from "../../useRangeSelectionChange";
import { useMemoModal } from "../../../components/Modal";
import { ModalContainer } from "../ModalContainer";
import { ManageAlerts } from "./Manage";
import { AddAlerts } from "./Add";

export const useConfigureAlertsModal = () => {
  const constraintRef = useModalDragConstraint();
  const modal = useMemoModal(
    (p: { active: "add" | "manage"; range?: TRangeSelection; width?: number; height?: number }) => {
      const range = p.range ?? [];
      return (
        <ModalTabs {...p} constrainRef={constraintRef} onClose={() => modal.close()}>
          <ModalContainer onClose={() => modal.close()}>
            <ModalTab id="add" title="Add Alerts">
              <AddAlerts selection={range} />
            </ModalTab>
            <ModalTab id="manage" title="Manage Alerts">
              <ManageAlerts selection={range} />
            </ModalTab>
          </ModalContainer>
        </ModalTabs>
      );
    },
  );

  return modal;
};
